// next-app/src/hooks/index.ts

// Query Keys (for manual invalidation in advanced cases)
export { queryKeys } from './query-keys';

// Authentication Hooks
export {
  useLogin,
  useSignup,
  useLogout,
  useForgotPassword,
  useResetPassword,
  useAccount,
} from './use-auth';

// Event Hooks
export {
  useEvents,
  useEventsList,
  useEvent,
  useEligibilityCheck,
  useCreateEvent,
  useSaveEventPlan,
  useSubmitEvent,
  useSaveReimbursement,
  useEventToken,
} from './use-events';

// Dealer Hooks
export { useDealer, useUpdateDealer } from './use-dealer';

// Respondent Hooks
export { useSend2FA, useRespondents, useRespondentsList } from './use-respondents';

// Survey Hooks
export {
  useSurveyConfig,
  usePreRegEvent,
  useSubmitSurvey,
  useSubmitVehiclesOfInterest,
  useSubmitVehiclesDriven,
} from './use-survey';

// Check-in Hooks
export { useCheckInData, useCheckIn, useFilteredCheckInParticipants } from './use-check-in';

// Check-out Hooks
export { useCheckOutData, useCheckOut, useFilteredCheckOutParticipants } from './use-check-out';

// Training Hooks
export {
  useTrainingProgress,
  useMarkTrainingComplete,
  useIsTrainingComplete,
  calculateTrainingProgress,
} from './use-training';
